import InputCompressed from './input-compressed.vue';
export default InputCompressed;



// WEBPACK FOOTER //
// ./src/components/input-compressed/index.js